/** All products for quote / enquiry dropdowns */
export const QUOTE_PRODUCT_OPTIONS = [
  'PE Coated Rolls',
  'Notebook Cover Jumbo Rolls',
  'Soap Stiffener Paper',
  'Food Wrap Paper',
  'Bakery Solutions',
  'Packaging',
  'PE Silver Coated Envelope Paper',
  'Paper Cup Sleeves',
  'Ripple Paper Cup Sleeves',
  'Paper Plates',
  'Sugar Sachets',
  'Pouches & Rolls',
  'Cup Bottoms',
  'Container Sleeves',
  'Box & Tray Sleeves',
  'Paper Bags',
  'Paper Carry Bags',
  'Other',
];
